// extracted by mini-css-extract-plugin
export default {"dashboardSection":"support_dashboardSection__hdLCl","support":"support_support__BwFJm","supportSection":"support_supportSection__q3G2X"};